// APIEndpoints.js

export const USER_LOGIN = "/admin/login";
export const USER_FORGOT_PASSWORD = `/admin/forgotPassword`;
export const USER_RESET_PASSWORD = `/admin/resetPassword`;
export const USER_LOGOUT = `/admin/logout`;
export const USER_PROFILE = `/admin/profile`;
export const USER_CHANGE_PASSWORD = `/admin/changePassword`;
export const ADMIN_CONTENT_DATA = `/admin/pageContent`;
export const ADMIN_USER_LIST = `/admin/users`;
export const ADMIN_SUBSCRIPTION_LIST = `/admin/subscriptions`;
export const ADMIN_SEND_BROADCAST = `/admin/sendBroadcast`;
export const ADMIN_BROADCAST_LIST = `/admin/broadcasts`;
export const ADMIN_BROADCAST_DELETE = `/admin/broadcasts`;
export const ADMIN_USER_DETAIL = `/admin/user`;
export const ADMIN_USER_TESTIMONIALS = `/admin/user/testimonials`;
export const ADMIN_DASHBOARD = `/admin/dashboard`;
export const ADMIN_OPERATIONS_STATUS = `/admin/operations/status`;
export const ADMIN_OPERATIONS_RESTART = `/admin/operations/restart`;
export const ADMIN_REFERRALS = `/admin/referrals`;
export const ADMIN_PLAN_LIST = "/user/v1/plan?fetchSubscriberCount=true";
export const ADMIN_USER_SUBSCRIBE = (userId) =>
  `/admin/user/${userId}/subscribe`;

export const ADMIN_BLOG_LIST = `/admin/blogs`;
export const ADMIN_BLOG_CREATE = `/admin/blog`;
export const ADMIN_BLOG_DETAIL = `/admin/blog`;
export const ADMIN_BLOG_UPDATE = `/admin/blog`;
export const ADMIN_BLOG_DELETE = `/admin/blog`;
